import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';
import styles from '../../../styles';

import { Icon } from '../../../icons';

const StyledIconLink = styled.a`
  font-family: 'ApercuMono';
  text-transform: uppercase;
  font-size: 1rem;
  
  ${styles.media.tablet`
    font-size: 1.5rem;
  `}
  ${styles.media.phone`
    font-size: 1rem;
  `}
  color: ${styles.color.ORANGE};
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  span {
    position: relative;
    transform: translate3d(0, 0, 0);
    transition-property: transform;
    transition-duration: .3s;
    transition-delay: 0s;
    transition-timing-function: ${styles.easing.outCubic};
  }
  
  figure {
    transition-property: transform, opacity;
    transition-duration: .25s;
    transition-timing-function: ${styles.easing.outCubic};
    width: 2rem;
    height: 2rem;
    transition-delay: .175s;
    margin-right: 0.5rem;
  }
}
`;

class IconLink extends Component {
  state = {
    hover: false,
  };

  onMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  onClick = e => {
    const { to } = this.props;
    e.preventDefault();

    window.open(to);
  };

  render() {
    const { className, children, isMouseOver, type } = this.props;
    const containerClassName = classnames(className, {
      hover: this.state.hover || isMouseOver,
    });
    const icon = type === 'appstore' ? '#app-store-icon' : '#google-play-icon';
    return (
      <StyledIconLink
        className={containerClassName}
        onMouseEnter={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
        onTouchStart={this.onMouseOver}
        onTouchEnd={this.onMouseOut}
        onClick={this.onClick}
      >
        <figure>
          <Icon icon={icon} />
        </figure>
        {children}
      </StyledIconLink>
    );
  }
}

IconLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  to: PropTypes.string,
  isMouseOver: PropTypes.bool,
  type: PropTypes.oneOf(['appstore', 'googleplay']),
};

export default IconLink;



// WEBPACK FOOTER //
// ./src/modules/pages/components/IconLink.js